import styles from '../styles/cards.module.css';
import { integrationText, TEXT } from '../texts';

function isHttps(url: string): boolean {
  try {
    return new URL(url).protocol === 'https:';
  } catch {
    return false;
  }
}

/** Login of this consultant to an integration; the URL comes from the worker and opens only over https. */
export function ConnectCard({ integration, url, closed }: { integration: string; url: string; closed: boolean }): React.JSX.Element {
  const { name, connectHint } = integrationText(integration);
  if (closed) return <div className={styles.closed}>{TEXT.connectDone(name)}</div>;
  const valid = isHttps(url);
  return (
    <div className={styles.card} role="group" aria-label={TEXT.connectTitle(name)}>
      <div className={styles.header}>{TEXT.connectTitle(name)}</div>
      <div>{TEXT.connectText(name)}</div>
      {connectHint !== undefined && <div className={styles.hint}>{connectHint}</div>}
      <div className={styles.actions}>
        <button type="button" className={styles.primary} disabled={!valid} onClick={() => window.open(url, '_blank', 'noopener,noreferrer')}>
          {TEXT.connectButton(name)}
        </button>
      </div>
      {!valid && <div className={styles.warning}>{TEXT.connectInvalidLink}</div>}
    </div>
  );
}
